module.exports = __webpack_public_path__ + "img/charger-speeds-mobile.9fb5fb36.webp";